export default "__VITE_ASSET__BRbS3fBH__"